import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Card = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 300px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  text-align: left;
  transition: transform 0.2s;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%; /* Ensures all cards have the same height */

  &:hover {
    transform: translateY(-5px);
  }
`;

const CardLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const CardImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

const CardDetails = styled.div`
  padding: 15px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end; /* Ensures content is aligned at the bottom */
`;

const CardTitle = styled.h3`
  margin: 0;
  font-size: 18px; /* Smaller font size */
  text-align: center; /* Center-align title */
`;

const ProjectCards = ({ project }) => {
  return (
    <Card>
      <CardLink to={`/how-to-apply/project/${project._id}`}>
        <CardImage src={project.imageUrl} alt={project.name} />
        <CardDetails>
          <CardTitle>{project.name}</CardTitle>
        </CardDetails>
      </CardLink>
    </Card>
  );
};

export default ProjectCards;
